import { useLocal } from '@/i18n/LocalContext'
import { useStore } from '@/store'
import { emitter } from '@app/emitter'
import { clickReport } from '@app/report'
import { Handler } from 'mitt'
import { useCallback, useEffect, useMemo, useState, useRef } from 'react'

export default function ActivityType() {
  const { $t } = useLocal()
  const { state } = useStore()
  const marketIsReward = state.marketData.isReward
  const isEnded = state.isEnded
  const isReward = state.isReward
  const coin = state.marketData.coin
  const lotteryIsReward = useMemo(() => isEnded && coin >= 120, [coin, isEnded])
  const [current, setCurrent] = useState<MittEvents['selectActivity']>(
    window.queryObj.current || 'main'
  )
  const classNameArray = useMemo(() => {
    const mainClassList = ['activity-type__item activity-type__item--main']
    if (isReward) {
      mainClassList.push('activity-type__item--reddot')
    }
    const marketClassList = ['activity-type__item activity-type__item--market']
    if (marketIsReward) {
      marketClassList.push('activity-type__item--reddot')
    }
    const lotteryClassList = [
      'activity-type__item activity-type__item--lottery',
    ]
    if (lotteryIsReward) {
      lotteryClassList.push('activity-type__item--reddot')
    }
    const currentClassName = 'activity-type__item--current'
    switch (current) {
      case 'main':
        mainClassList.push(currentClassName)
        break
      case 'market':
        marketClassList.push(currentClassName)
        break
      case 'lottery':
        lotteryClassList.push(currentClassName)
        break

      default:
        break
    }
    return [
      mainClassList.join(' '),
      marketClassList.join(' '),
      lotteryClassList.join(' '),
    ]
  }, [current, marketIsReward, isReward, lotteryIsReward])

  const handleSelect = useCallback((val: MittEvents['selectActivity']) => {
    setCurrent(val)
    clickReport(
      {
        main: 'anniversary',
        market: 'market',
        lottery: 'gift_box',
      }[val] as Parameters<typeof clickReport>[0]
    )
    emitter.emit('selectActivity', val)
    if (val === 'market') {
      emitter.emit('updateMarketData')
    }
  }, [])

  const initCount = useRef(0)
  useEffect(() => {
    setTimeout(() => {
      if (initCount.current > 0) return
      initCount.current++

      if (typeof current === 'string' && current.length > 0) {
        console.log('初始活动类型 =>', current)
        handleSelect(current)
      }
    }, 4)

    const handler: Handler<MittEvents['selectActivity']> = (activity) => {
      setCurrent(activity)
    }
    emitter.on('selectActivity', handler)

    return () => {
      emitter.off('selectActivity', handler)
    }
  }, [])

  return (
    <nav className="activity-type">
      <a className={classNameArray[0]} onClick={() => handleSelect('main')}>
        <p className="activity-type__item-text">{$t('圣诞庆典')}</p>
        <div className="activity-type-reddot"></div>
      </a>
      <a className={classNameArray[1]} onClick={() => handleSelect('market')}>
        <p className="activity-type__item-text">{$t('圣诞集市')}</p>
        <div className="activity-type-reddot"></div>
      </a>
      <a className={classNameArray[2]} onClick={() => handleSelect('lottery')}>
        <p className="activity-type__item-text">{$t('圣诞礼盒')}</p>
        <div className="activity-type-reddot"></div>
      </a>
    </nav>
  )
}
